import { Directive, ElementRef, Input, OnChanges, SimpleChange } from '@angular/core';

@Directive({
  selector: '[gtdUrlHighlight]',
})
export class UrlHighlightDirective implements OnChanges {
  @Input() gtdUrlHighlight = '';
  @Input() urlTemplate = '';

  constructor(private el: ElementRef) {}

  public ngOnChanges({ gtdUrlHighlight, urlTemplate }: { gtdUrlHighlight: SimpleChange; urlTemplate: SimpleChange }) {
    if (gtdUrlHighlight?.currentValue && urlTemplate?.currentValue) {
      this.el.nativeElement.innerHTML = this.gtdUrlHighlight.replace(
        urlTemplate.currentValue,
        `<span class="search-result__url-option_highlight">${urlTemplate.currentValue}</span>`
      );
    }
  }
}
